export default __webpack_public_path__ + "static/media/comparison-EN.8a6cc844.mp4";